// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Dispatcher_1 = require("../Dispatcher");
var assert_1 = require("../util/assert");
/*
 StoreGroup

 - must have `#onChange((stores) => {}): void`
 - must have `#getState(): Object`
 - may have `#release(): void`

 */
var StoreGroupValidator = /** @class */ (function () {
    function StoreGroupValidator() {
    }
    /**
     * validate the instance is StoreGroup-like object
     * Context treat StoreGroup like object as StoreGroup.
     */
    StoreGroupValidator.validateInstance = function (storeGroup) {
        assert_1.assertOK(storeGroup !== undefined, "store should not be undefined");
        assert_1.assertOK(Dispatcher_1.Dispatcher.isDispatcher(storeGroup), "storeGroup should be inherited Dispatcher");
        assert_1.assertOK(typeof storeGroup.onChange === "function", "StoreGroup should have #onChange method");
        assert_1.assertOK(typeof storeGroup.getState === "function", "StoreGroup should have #getState method");
        // #release is optional
        assert_1.assertOK(typeof storeGroup.release === "undefined" || typeof storeGroup.release === "function", "StoreGroup may have #release method");
    };
    return StoreGroupValidator;
}());
exports.StoreGroupValidator = StoreGroupValidator;
//# sourceMappingURL=StoreGroupValidator.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UILayer/StoreGroupValidator.js
// module id = 479
// module chunks = 0